// extracted by mini-css-extract-plugin
export default {"bgLightGrey":"style_bgLightGrey__BWTIG","bgGrey":"style_bgGrey__xAse9","minHeight":"style_minHeight__yxBGx","customWidthHeight":"style_customWidthHeight__DZLoV"};